import './index.css';
import { WeekSelector } from '../weekSelector';
import { BookingTable } from '../bookingTable';
import { AddBookingSlotModal } from '../addBookingSlotModal';
import { useState } from 'react';
import { BookingSlot } from '../../api-types/models/Booking';
import { format, startOfWeek } from 'date-fns';
import { RoomSelector } from '../roomSelector';
import {
    useGetBookingActivitiesQuery,
    useGetSlotsForWeekQuery
} from '../../api/bookingApi';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { selectRoom, setRoom } from '../../app/bookingSlice';

interface IProps {
    rooms: string[];
}

export function BookingCalendar({ rooms }: IProps) {
    const dispatch = useAppDispatch();
    const selectedRoom = useAppSelector(selectRoom);

    const [selectedDate, setSelectedDate] = useState<Date>();
    const [startOfWeekDate, setStartOfWeekDate] = useState(
        startOfWeek(new Date(), { weekStartsOn: 1 })
    );
    const [selectedSlot, setSelectedSlot] = useState<BookingSlot>();

    const weekDateIso = format(startOfWeekDate, 'yyyy-MM-dd');
    const { data: slotsPerWeek = [] } = useGetSlotsForWeekQuery(weekDateIso);
    const { data: activities = [] } = useGetBookingActivitiesQuery(
        selectedRoom,
        { skip: !selectedRoom }
    );

    const closeSlotModal = () => {
        setSelectedDate(undefined);
        setSelectedSlot(undefined);
    };

    return (
        <>
            <div className='booking-calendar-header'>
                <WeekSelector
                    startOfWeekDate={startOfWeekDate}
                    setStartOfWeekDate={setStartOfWeekDate}
                />
                <RoomSelector
                    rooms={rooms}
                    selectedRoom={selectedRoom}
                    setValue={(room) => dispatch(setRoom(room))}
                />
            </div>
            <BookingTable
                startOfWeekDate={startOfWeekDate}
                setSelectedDate={setSelectedDate}
                slotsPerWeek={slotsPerWeek.filter(
                    (slot) => slot.room === selectedRoom
                )}
                setSelectedSlot={(slot) => {
                    setSelectedSlot(slot);
                    setSelectedDate(new Date(slot.from));
                }}
            />
            {(selectedDate || selectedSlot) && (
                <AddBookingSlotModal
                    date={selectedDate}
                    setDate={setSelectedDate}
                    closeModal={closeSlotModal}
                    rooms={rooms}
                    selectedRoom={selectedRoom}
                    activities={activities}
                    addOrUpdateSlot={(_slot, _update) => closeSlotModal()}
                    slot={selectedSlot}
                    deleteSlot={(_slot) => closeSlotModal()}
                    slotsPerWeek={slotsPerWeek.filter(
                        (s) => s.room === selectedRoom
                    )}
                />
            )}
        </>
    );
}
